import { render, staticRenderFns } from "./search-form-item-clear.vue?vue&type=template&id=16fe928f&scoped=true"
import script from "./search-form-item-clear.vue?vue&type=script&lang=js"
export * from "./search-form-item-clear.vue?vue&type=script&lang=js"
import style0 from "./search-form-item-clear.vue?vue&type=style&index=0&id=16fe928f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fe928f",
  null
  
)

export default component.exports